import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetchLiveChannels } from "../../Screens/LiveChannels/service";
import { DEVICES_LIST, SPORTS_PAGE_DATA } from "../../Screens/Sports/sportsPageData";

const getGenreName = (page, key) => {
  if (key === "action-extreme-sports") return "Action Sports";
  return page.title
    .replace(/^Watch\s+/i, "")
    .replace(/\s+(Online|Live)$/i, "");
};

const FlsPageFooter = ({ showHowToWatch = true, showDirectory = true }) => {
  const navigate = useNavigate();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    if (!showDirectory) return undefined;

    let active = true;
    fetchLiveChannels({ projectDetails: projectInfo, accessToken, sessionId })
      .then((response) => {
        if (active) setChannels(response?.data?.data?.channels || []);
      })
      .catch(() => {
        if (active) setChannels([]);
      });

    return () => {
      active = false;
    };
  }, [accessToken, projectInfo, sessionId, showDirectory]);

  const genres = useMemo(
    () => Object.entries(SPORTS_PAGE_DATA).map(([key, page]) => ({
      key,
      name: getGenreName(page, key),
    })),
    []
  );

  const openChannelInfo = (channel) => {
    const channelId = channel?.id || channel?.channel_id;
    const vanityUrl =
      channel?.vanity_url ||
      channel?.vanityUrl ||
      channel?.channel_name?.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") ||
      channelId;
    navigate(`/channel/${vanityUrl}`);
  };

  return (
    <>
      {showHowToWatch && (
        <section className="flsHowToWatchFooter">
          <div className="flsFooterContainer">
            <h2>How To Watch</h2>
            <div className="flsDevicesGrid">
              {DEVICES_LIST.map((device) => (
                <div className="flsDevice" key={device.name}>
                  <img src={device.icon} alt="" />
                  <span>{device.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {showDirectory && (
        <section className="flsDirectoryFooter">
          <div className="flsFooterContainer flsDirectoryGrid">
            <div className="flsDirectoryColumn">
              <h2>Channels</h2>
              <div className="flsDirectoryLinks flsChannelLinks">
                {channels.map((channel) => (
                  <button
                    key={channel.id}
                    type="button"
                    onClick={() => openChannelInfo(channel)}
                  >
                    <span aria-hidden="true">›</span>
                    {channel.channel_name}
                  </button>
                ))}
              </div>
            </div>
            <div className="flsDirectoryColumn">
              <h2>Sports Genres</h2>
              <div className="flsDirectoryLinks">
                {genres.map((genre) => (
                  <button key={genre.key} type="button" onClick={() => navigate(`/sport/${genre.key}`)}>
                    <span aria-hidden="true">›</span>
                    {genre.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default FlsPageFooter;